/** DOM markers shared by the picking roots, the Copilot composer and the global picking styles. */
export const CONTEXT_PICKING_SCREEN_ATTRIBUTE = 'data-copilot-picking';
export const CONTEXT_PICKING_ROOT_ATTRIBUTE = 'data-copilot-picking-root';
/** Controls that keep acting while picking, never admitted as picks: the selector toggle, the
 * list of what was picked and the AI island that opens and closes Copilot. */
export const CONTEXT_PICKING_TOGGLE_ATTRIBUTE = 'data-copilot-picking-toggle';
export const CONTEXT_PICK_HOVER_ATTRIBUTE = 'data-copilot-pick-hover';
export const CONTEXT_PICKED_ATTRIBUTE = 'data-copilot-picked';
export const CONTEXT_PICKING_CURSOR_PROPERTY = '--copilot-picking-cursor';
/** A layer that lies over its whole view region (a fullscreen view): what is under it is not read. */
export const VIEW_COVERING_LAYER_ATTRIBUTE = 'data-view-covering-layer';
/** Markup a drawn surface delivers as its objects' text (a PDF page's glyphs): the DOM read leaves it out. */
export const SURFACE_DELIVERED_CONTENT_ATTRIBUTE =
  'data-surface-delivered-content';
